
<template>
  <div class="content">
    <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
 <div>
        <router-link :to="{ path: '/leader'}">
          <button type="submit" class="btn btn-info btn-sm  px-3 mr-3">İçerik</button>
        </router-link>
        <router-link :to="{ path: '/leader/gallery'}">
          <button type="submit" class="btn btn-warning btn-sm mr-3 px-3">Fotogaleri</button>
        </router-link>
        <router-link :to="{ path: '/leader/pressgallery'}">
          <button type="submit" class="btn btn-danger active btn-sm mr-3 px-3">Yazılı Basın</button>
        </router-link>
        <router-link :to="{ path: '/leader/articles'}">
          <button type="submit" class="btn btn-success btn-sm mr-3 px-3">Başkanın Yazıları</button>
        </router-link>
        <router-link :to="{ path: '/leader/articlesorder'}">
          <button type="submit" class="btn btn-primary btn-sm mr-3 px-3">Yazı Sıralama</button>
        </router-link>
        <router-link :to="{ path: '/leader/digital-press'}">
          <button type="submit" class="btn btn-secondary btn-sm  mr-3 px-3">Dijital Basın</button>
        </router-link>
        <router-link :to="{ path: '/leader/digital-press-order'}">
          <button type="submit" class="btn btn-info btn-sm mr-3 px-3">Dijital Basın Sıralama</button>
        </router-link>
      </div>
      <span></span>
    </div>
    <card>
      <div class="row">
        <div class="col-12" v-if="!err">
          <div class="card">
            <div class="card-body">
              <h4 class="d-flex justify-content-between mt-0">
                <span>
                  Başkanın Köşesi Yazılı Basın
                  <small
                    class="small text-primary"
                  >(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)</small>
                </span>
                <div class="d-flex">
                  <button class="mr-2 btn btn-danger btn-sm btn-fill" v-on:click="addNew()">Ekle</button>
                  <button class="btn btn-primary btn-sm btn-fill" v-on:click="update()">Kaydet</button>
                </div>
              </h4>
              <small class="d-block w-100 mb-3">Resim boyutu 600 x 400 pixel</small>
              <draggable v-model="slider" :options="{animation:200}" @update="update()">
                <transition-group>
                  <div v-for="(item, index) in slider" :key="index+1">
                    <div class="card mb-2 menu-item">
                      <div class="card-body row">
                        <div class="col-11">
                          <img width="150px" class="img-fluid" :src="mediaURL() + item.image" />
                        </div>

                        <div class="col-1 d-flex justify-content-end align-items-center">
                          <div class="d-flex flex-column">
                            <button
                              v-b-modal.croppieModal
                              v-on:click="initiateCroppie(item.id,index,0)"
                              v-b-tooltip
                              title="Resmi Değiştir"
                              class="btn btn btn-sm"
                            >
                              <i class="fas fa-image fa-fw"></i>
                            </button>
                            <button v-on:click="remove(item.id)" class="btn btn-danger btn-sm mt-1">
                              <i class="fas fa-times fa-fw"></i>
                            </button>
                          </div>

                          <img
                            v-bind:src="newSliderImage.cropped"
                            class="img-fluid mt-4 border border-secondary p-2 d-none"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
        <div v-if="err">
          {{err}}
        </div>
      </div>
      <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
        <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()" />
        <vue-croppie
          :enable-resize="false"
          :viewport="{width: 480, height: 320, type: 'suare'}"
          :boundary="{width: 600, height: 400}"
          ref="main"
          :enableOrientation="true"
          @result="result"
        ></vue-croppie>
        <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
        <b-btn
          class="mt-3"
          id="submit-image"
          variant="success btn-fill float-right"
          @click="changeButtonText()"
        >Kaydet</b-btn>
      </b-modal>
    </card>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import { ModelSelect } from "vue-search-select";

export default {
  data: function() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "pressgallery",
        order_number: null
      }],
      err:null,
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card,
    ModelSelect
  },

  methods: {
    remove: function(id) {
      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(
          response => {
            this.notifier("top", "right", "danger", "Slider Başarıyla silindi");
            this.getSlider();
          },
          e => {
                                              if(!e.body.Error){
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            }else{
            this.notifier("top", "right", "danger", e.body.Error);
            }
          }
        );
      }
    },
    uploadImage: function() {
      this.$http
        .post("/api/images/upload/new-gallery", this.newSliderImage)
        .then(
          response => {
            var i = this.newSliderImage.n === 0 ? "image" : "image2";
            this.slider[this.newSliderImage.imageIndex][i] =
              response.body.Data.Response.name;
            this.toggleLoader();
            this.hideCroppieModal();
            this.update();
          },
          e => {
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            this.toggleLoader();
          }
        );
    },
    addNew: function() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "pressgallery",
        order_number: null
      });
    },
    update: function() {
      var newdis = this;
      this.slider.forEach(function(s) {
        if (!s.image) s.image = s.image2;
        s.image_type = "pressgallery";
      });
      this.$http.post("/api/images/edit/", this.slider).then(
        response => {
          this.notifier("top", "right", "success", "Değişiklikler Kaydedildi");
          this.getSlider();
        },
        e => {
                                                                  if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    getSlider: function() {
      var url = "/api/images/get-with-type/pressgallery";
      this.$http.get(url).then(
        response => {
          this.slider = response.body;
        },
        er => {
if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
        }
      );
    },
    initiateCroppie: function(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function(oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    changeButtonText: function() {
      this.crop();
    },
    crop() {
      var dis = this;
      this.toggleLoader();
      return new Promise(resolve => {
        let options = {
          format: "jpeg" | "png" | "webp",
          backgroundColor: "#fff",
          size: {
            width: 600,
            height: 400
          },
          quality: 1
        };
        dis.$refs.main.result(options, output => {
          this.newSliderImage.cropped = output;
          this.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result(output) {
      return output;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getSlider();
    });
  }
};
</script>
<style>
div#croppieModal {
    display: flex!important;
    align-items: center;
    justify-content: center;
    height: 100%!important;
}

div#croppieModal .modal-dialog {
    transform: none!important;
}
.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: #007bff !important;
}
.nav-pills:focus {
  outline: none;
}
.nav-pills a {
  color: #000;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  color: #fff;
}
.nav-item {
  margin-bottom: 5px;
}
.menu-item:hover {
  cursor: move;
}

.bg-gray {
  background-color: #bdc3c7 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PressGalleryModules/Index.vue